module.exports = __webpack_public_path__ + "static/media/29ADMSPC30.f43c3c03.jpg";